import $ from '@ali/tarzan-zepto';
// import goldlog from '@ali/goldlog';
import util from '../../../lib/util.js';
import BaseUI from '../../../component/baseui/index';
import tpl from './tpl.html';
import EventBus from '../../context/eventbus.js';

// INCLUDE STYLES
import './style.scss';

// DEFINE USER PRESS EVENT
const isPc = util.isPC();
const press = isPc ? 'click' : 'tap';

function __bindEvent($node) {
  $node.find('[data-button="login"]').on(press, () => {
    EventBus.emit('liveAgent', {
      entry: 'liveAgent',
    });
  });
}

export default function agentChatLogin(data) {
  const app = this;
  const eventLoginParams = data.loginParams || {
    email: null,
    type: 'registered',
  };
  data.loginButtonText = app.util.lang.get('BUTTON:LOGIN');

  const params = {
    name: 'agentChatLogin',
    mid: data.mid,
    content: tpl.render(data),
  };

  const $node = $(BaseUI.msg(params));

  __bindEvent($node, eventLoginParams);

  return {
    body: $node,
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/agent-chat-login/index.js